module.exports = __webpack_public_path__ + "img/06.010daeb9.png";